import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface MyPayeeTargets {
  cleanerId: string | null;
  companyIds: string[];
}

/** Resolves current user to payee target(s): cleaner id (if user has cleaners row) and company ids (companies where user is admin). Used to filter invoices for /account/payments. */
export function useMyPayeeTargets() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["my-payee-targets", user?.id],
    queryFn: async (): Promise<MyPayeeTargets> => {
      if (!user?.id) return { cleanerId: null, companyIds: [] };

      const [cleanerRes, companiesRes] = await Promise.all([
        supabase
          .from("cleaners")
          .select("id")
          .eq("user_id", user.id)
          .maybeSingle(),
        supabase
          .from("cleaning_companies")
          .select("id")
          .eq("admin_user_id", user.id),
      ]);

      const cleanerId = (cleanerRes.data as { id?: string } | null)?.id ?? null;
      const companyIds = ((companiesRes.data ?? []) as { id: string }[]).map((r) => r.id);

      return { cleanerId, companyIds };
    },
    enabled: !!user?.id,
  });
}
